import axiosClient from './axiosClient';

export const QualificationApi = {
  get: (data) => {
    return axiosClient.post('/api/qualification/get', data);
  },

  createQualification: (data) => {
    return axiosClient.post('/api/qualification/create', data);
  },

  update: (data) => {
    return axiosClient.post('/api/qualification/edit', data);
  },

  delete: (data) => {
    return axiosClient.post('/api/qualification/delete', data);
  },
  getDropdown: (data) => {
  return axiosClient.post('/api/qualification/dropdown', data);
},
};